import React from 'react'
import Button from '@material-ui/core/Button'

const AudienceChooser = ({ publicCall, classes, sm, onChooseExisting, onChooseNew }) => (
  <div className={classes[sm ? 'buttons-sm' : 'buttons']}>
    <Button
      className={classes[sm ? 'button-sm' : 'button']}
      variant="contained"
      color="primary"
      onClick={onChooseExisting}
    >
      {publicCall.studyInTheNetworkButtonText}
    </Button>

    <Button
      className={classes[sm ? 'button-sm' : 'button']}
      variant="contained"
      color="primary"
      onClick={onChooseNew}
    >
      {publicCall.dontStudyInTheNetworkButtonText}
    </Button>
  </div>
)

export default AudienceChooser
